(function(){
  var money = window.Shopify && Shopify.currency ? null : null;
  function formatMoney(cents){
    var v = (cents/100).toFixed(2);
    return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg){
    var t=document.getElementById('toast'); if(!t) return;
    t.textContent=msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer=setTimeout(function(){t.classList.remove('show')},2200);
  }

  /* ---------- cart drawer ---------- */
  function openCart(){
    var d=document.getElementById('cartDrawer'), s=document.getElementById('cartScrim');
    if(!d) return; d.classList.add('open'); s.classList.add('show'); document.body.classList.add('no-scroll');
    refreshCart();
  }
  function closeCart(){
    var d=document.getElementById('cartDrawer'), s=document.getElementById('cartScrim');
    if(!d) return; d.classList.remove('open'); s.classList.remove('show'); document.body.classList.remove('no-scroll');
  }
  window.mairOpenCart = openCart;
  window.mairCloseCart = closeCart;

  function renderCart(cart){
    var body=document.getElementById('cartBody'); if(!body) return;
    var countEls=document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function(el){ el.textContent = cart.item_count ? '('+cart.item_count+')' : ''; });
    if(!cart.items || cart.items.length===0){
      body.innerHTML = '<div class="cart-drawer__empty"><p class="cart-empty">Your cart is empty</p>'+
        '<a href="/collections/all" class="cart-cta">Shop the collection</a></div>';
      return;
    }
    var html='';
    cart.items.forEach(function(it){
      var img = it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_120x$1$2') : '';
      html += '<div class="cart-line">'+
        (img ? '<img class="cart-line__img" src="'+img+'" alt="">' : '<div class="cart-line__img"></div>')+
        '<div class="cart-line__info">'+
          '<div class="cart-line__name">'+it.product_title+'</div>'+
          '<div class="cart-line__price">'+formatMoney(it.final_line_price)+'</div>'+
          '<button class="cart-line__remove" data-remove="'+it.key+'">Remove</button>'+
        '</div></div>';
    });
    html += '<div class="cart-foot">'+
      '<div class="cart-foot__row"><span>Subtotal</span><span>'+formatMoney(cart.total_price)+'</span></div>'+
      '<a href="/checkout" class="cart-cta" style="display:block">Checkout</a></div>';
    body.innerHTML = html;
    body.querySelectorAll('[data-remove]').forEach(function(b){
      b.addEventListener('click', function(){ changeLine(b.getAttribute('data-remove'), 0); });
    });
  }

  function refreshCart(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();}).then(renderCart).catch(function(){});
  }
  function changeLine(key, qty){
    fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id:key, quantity:qty})
    }).then(function(r){return r.json();}).then(renderCart).catch(function(){});
  }

  /* add to cart (PDP) */
  function bindAddToCart(){
    document.querySelectorAll('[data-add-to-cart]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var id = btn.getAttribute('data-variant-id');
        var name = btn.getAttribute('data-product-name') || 'Item';
        if(!id) return;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:id, quantity:1}]})
        }).then(function(r){return r.json();}).then(function(){
          btn.disabled = false;
          toast(name + ' added to cart');
          openCart();
        }).catch(function(){ btn.disabled=false; });
      });
    });
  }

  /* cart links / icons */
  function bindCartTriggers(){
    document.querySelectorAll('[data-cart-open]').forEach(function(a){
      a.addEventListener('click', function(e){ e.preventDefault(); openCart(); });
    });
    var close=document.getElementById('cartClose'); if(close) close.addEventListener('click', closeCart);
    var scrim=document.getElementById('cartScrim'); if(scrim) scrim.addEventListener('click', closeCart);
  }

  /* ---------- header scroll (home only) ---------- */
  function bindHeaderScroll(){
    var navEl=document.getElementById('nav');
    var videosEl=document.querySelector('.videos');
    if(!navEl || !videosEl) return;
    function onScroll(){
      var threshold = videosEl.offsetHeight - 80;
      if(window.scrollY > threshold) navEl.classList.add('hide');
      else navEl.classList.remove('hide');
    }
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  /* ---------- sort dropdown (shop page) ---------- */
  function bindSort(){
    var sortby=document.getElementById('sortby'); if(!sortby) return;
    var sortBtn=document.getElementById('sortBtn');
    var sortMenu=document.getElementById('sortMenu');
    var current=sortby.querySelector('.sortby__current');
    sortBtn.addEventListener('click', function(e){
      e.stopPropagation();
      var open=sortby.classList.toggle('open');
      sortBtn.setAttribute('aria-expanded', open?'true':'false');
    });
    document.addEventListener('click', function(){ sortby.classList.remove('open'); sortBtn.setAttribute('aria-expanded','false'); });
    sortMenu.querySelectorAll('li').forEach(function(li){
      li.addEventListener('click', function(){
        sortMenu.querySelectorAll('li').forEach(function(x){x.classList.remove('is-active')});
        li.classList.add('is-active');
        if(current) current.textContent = li.textContent;
        applySort(li.dataset.value);
        sortby.classList.remove('open'); sortBtn.setAttribute('aria-expanded','false');
      });
    });
  }
  function applySort(mode){
    var grid=document.getElementById('shopGrid'); if(!grid) return;
    var items=Array.prototype.slice.call(grid.querySelectorAll('.scard'));
    items.sort(function(a,b){
      if(mode==='featured') return (+a.dataset.index)-(+b.dataset.index);
      var pa=+a.dataset.price, pb=+b.dataset.price;
      return mode==='low'? pa-pb : pb-pa;
    });
    items.forEach(function(it){ grid.appendChild(it); });
  }

  document.addEventListener('DOMContentLoaded', function(){
    bindCartTriggers();
    bindAddToCart();
    bindHeaderScroll();
    bindSort();
    refreshCart();
  });
})();
